import React from "react";
import { useScrollToTop } from "../components/hooks/scrollToTopHook";
import { PicksSubmittedView } from "../views/PicksSubmittedView";
import { useEvent } from "../contexts/EventContext";
import { useApplication } from "../contexts/ApplicationContext";

export const PicksSubmittedController = (): JSX.Element => {
    const { appDispatch } = useApplication();

    const { currentEvent, currentEntry, clearSubmittedScreen } = useEvent();

    const handlePicks = () => {
        clearSubmittedScreen();
    };
    useScrollToTop();

    if (!currentEvent || !currentEntry) {
        return <></>;
    }

    return (
        <PicksSubmittedView
            event={currentEvent}
            entry={currentEntry}
            handleLeaderboard={() => appDispatch({ type: "showLeaderboard", eventId: currentEvent.id })}
            handlePicks={handlePicks}
        />
    );
};
